import React, { useState, useEffect, useRef } from "react";
import { TextField,Tooltip, } from "@mui/material";
import axios from "../../axios-order";
import BoxWrapper from "../../components/ui/boxWrapper";
import Snackbar from "@material-ui/core/Snackbar";
import moment from "moment";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory } from "react-router-dom";
import IconButton from "@mui/material/IconButton"; // Import MUI IconButton
import DownloadIcon from "@mui/icons-material/Download";
import MuiAlert from "@material-ui/lab/Alert";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { canWrite } from '../../utils/privilegeUtils';
const apiUrl = process.env.REACT_APP_BACKEND_BASE_URL;

export default function Gst2aRepository() {
  const fileInputRef = useRef(null);
  const history = useHistory();


  const [fileName, setFileName] = useState("");
  const [fileDataToUpload, setFileDataToUpload] = useState("");
  const [trigarCircularProgress, setTrigarCircularProgress] = useState(false);

  //...............For Error Message..........................
  const [colorForErrorMessage, setColorForErrorMessage] = useState("red");
  const [errorMessage, setErrorMessage] = useState("");
  const [errorMessageVisibilityStyle, setErrorMessageVisibilityStyle] =
    useState("hidden");
  const [errorMessageDisplayStyle, setErrorMessageDisplayStyle] =
    useState("none");

  //.........Record From Get Api.................
  const [recordFromApi, setRecordFromApi] = useState([]);
  const [recordFromApiForSearch, setRecordFromApiForSearch] = useState([]);

  const [loaderForTable, setLoaderForTable] = useState(false);
  const [loaderForFileUpload, setLoaderForFileUpload] = useState(false);

  //This is for Gst Auto Download
  const [fromMonthYearDisplay, setFromMonthYearDisplay] = useState("");
  const [fromToYearDisplay, setFromToYearDisplay] = useState("");
  const [responseMessage, setResponseMessage] = useState("");

  //SnackBar
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [message, setMessage] = useState("");


  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  // Function to close Snackbar
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
    setSnackbarSeverity("success");
    setResponseMessage("");
  };

  const fileUploadCancelButtonHandler = () => {
    setTrigarCircularProgress(false);
    setColorForErrorMessage("red");

    // Clear error message and upload states
    setErrorMessage("");
    setFileDataToUpload("");
    setFileName("");
    setLoaderForFileUpload(false);
    // Reset file input field to allow re-uploading the same file
    if (fileInputRef.current) {
      fileInputRef.current.value = null; // Clears the input value
    }
  };

  //......Handle Search....................
  const handleSearch = (e) => {
    let Search = e.target.value;
    const searchName = recordFromApiForSearch.filter((v) => {
      return (
        String(v.gstr_upload_file_type)
          .toLowerCase()
          .indexOf(Search.toLowerCase()) >= 0 ||
        String(v.financial_year).toLowerCase().indexOf(Search.toLowerCase()) >=
        0 ||
        String(v.generation_date).toLowerCase().indexOf(Search.toLowerCase()) >=
        0 ||
        String(v.upload_date).toLowerCase().indexOf(Search.toLowerCase()) >=
        0 ||
        String(moment(v.tax_period, "MMYYYY").format("MMMM-YYYY"))
          .toLowerCase()
          .indexOf(Search.toLowerCase()) >= 0
      );
    });
    setRecordFromApi(searchName);
  };

  //........For Succesfull Message..................
  const functionForSuccesfullMessage = () => {
    setColorForErrorMessage("green");
    setErrorMessageVisibilityStyle("visible");
    setErrorMessageDisplayStyle("block");
    // setErrorMessage("Data Fetched Successfully");
    // setTimeout(() => handleOpenAndClose(), 3000);
  };

  const handleFileUpload = (e) => {
    setErrorMessageVisibilityStyle("hidden");
    setErrorMessageDisplayStyle("none");
    setErrorMessage("");

    if (e.target.files.length) {
      const file_data = e.target.files[0];
      let fileName = file_data.name;
      setFileName(fileName);

      // Check for PDF file type
      const fileType = file_data.type;
      if (fileType !== "application/pdf") {
        // Handle invalid file type
        setErrorMessageVisibilityStyle("visible");
        setErrorMessageDisplayStyle("block");
        setErrorMessage("Please attach only PDF files!");
        setLoaderForFileUpload(false);
        return; // Exit if the file is not a PDF
      }

      const reader = new FileReader();
      reader.readAsDataURL(file_data);
      reader.onload = function () {
        let file_value = reader.result;
        setFileDataToUpload(file_value);
      };
    }
  };

  const handleBackNavigation = () => {
    history.push("/repoCards");
  };


  const handleSubmitEvent = (e) => {
    e.preventDefault(); // Prevent default form submission behavior

    if (fileDataToUpload === "") {
      setErrorMessageVisibilityStyle("visible");
      setErrorMessageDisplayStyle("block");
      setErrorMessage("Please Upload The File!");
      setLoaderForFileUpload(false);
      window.setTimeout(() => {
        setErrorMessageVisibilityStyle("hidden");
      }, 2000);
      return;
    }

    setTrigarCircularProgress(true);
    setLoaderForFileUpload(true);

    const business_entity_id = localStorage.getItem("business_entity_id");
    const filename = fileName;

    axios
      .post(`/ais/upload_file`, {
        business_entity_id: business_entity_id,
        file: fileDataToUpload,
        document_name: filename,
        password: password,
      })
      .then((res) => {
        setTrigarCircularProgress(false);
        setLoaderForFileUpload(false);

        if (res.data.status === false) {
          setErrorMessageVisibilityStyle("visible");
          setErrorMessageDisplayStyle("block");
          setErrorMessage(res.data.message);
        } else {
          setErrorMessage(res.data.message);
          functionForSuccesfullMessage();
          getApiForGst2aRepository();

          // Clear success message and reset form after 3 seconds
          setTimeout(() => {
            setErrorMessage(""); // Clear the success message
            setFileDataToUpload(""); // Clear the file data
            setFileName(""); // Clear the filename
            setPassword(""); // Clear the password
            if (fileInputRef.current) {
              fileInputRef.current.value = null; // Clear the file input
            }
          }, 3000); // Clear after 3 seconds
        }
      })
      .catch((error) => {
        setErrorMessageVisibilityStyle("visible");
        setErrorMessageDisplayStyle("block");
        setErrorMessage(error.response?.data?.message || "An error occurred");
        setLoaderForFileUpload(false);
      });
  };

  // Submit Event For File Upload in axios
  // const handleSubmitEvent = (e) => {
  //   e.preventDefault(); // Prevent default form submission behavior

  //   if (fileDataToUpload === "") {
  //     setErrorMessageVisibilityStyle("visible");
  //     setErrorMessageDisplayStyle("block");
  //     setErrorMessage("Please Upload The File!");
  //     setLoaderForFileUpload(false);
  //     window.setTimeout(() => {
  //       setErrorMessageVisibilityStyle("visible");
  //     }, 2000);
  //   } else {
  //     setTrigarCircularProgress(true);
  //     setLoaderForFileUpload(true);

  //     const business_entity_id = localStorage.getItem("business_entity_id");
  //     const filename = fileName; // Get the filename

  //     axios
  //       .post(`/ais/upload_file`, {
  //         business_entity_id: business_entity_id,
  //         file: fileDataToUpload,
  //         document_name: filename,
  //         // password:password // Pass the filename as part of the payload
  //       })
  //       .then((res) => {
  //         setTrigarCircularProgress(false);
  //         setLoaderForFileUpload(false);

  //         if (res.data.status === false) {
  //           setErrorMessageVisibilityStyle("visible");
  //           setErrorMessageDisplayStyle("block");
  //           setErrorMessage(res.data.message);
  //         } else {
  //           setErrorMessage(res.data.message);
  //           functionForSuccesfullMessage();
  //           getApiForGst2aRepository();

  //           // Clear success message and reset form after 3 seconds
  //           setTimeout(() => {
  //             setErrorMessage(""); // Clear the success message
  //             setFileDataToUpload(""); // Clear the file data
  //             setFileName(""); // Clear the filename
  //             if (fileInputRef.current) {
  //               fileInputRef.current.value = null; // Clear the file input
  //             }
  //           }, 3000); // Clear after 3 seconds
  //         }
  //       })
  //       .catch((error) => {
  //         setErrorMessageVisibilityStyle("visible");
  //         setErrorMessageDisplayStyle("block");
  //         setErrorMessage(error.response?.data?.message || "");
  //         setLoaderForFileUpload(false);
  //       });
  //   }
  // };


  //.......................Get Api For Gst................
  const getApiForGst2aRepository = () => {
    setLoaderForTable(true);
    const business_entity_id = localStorage.getItem("business_entity_id");
    axios
      .get(`/ais/get_ais_data/${business_entity_id}`)
      .then((res) => {
        if (res.data.status === false) {
          setLoaderForTable(false);
        } else {
          setLoaderForTable(false);
          setRecordFromApi(res.data.data);
          //   setRecordFromApiForSearch(res.data.record);
        }
      })
      .catch((error) => {
        setLoaderForTable(false);
        setErrorMessage("Error Fetching Data");
      });
  };

  useEffect(() => {
    getApiForGst2aRepository();
  }, []);


  const handleDownload = (id) => {
    const business_entity_id = localStorage.getItem('business_entity_id');

    axios.get(`/ais/download/${business_entity_id}/${id}`)
      .then((response) => {
        // Assuming the file data is under the `file` key and it's base64 encoded
        const base64Data = response.data.file;

        // Convert base64 string to binary data
        const binaryString = window.atob(base64Data);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }

        // Create a Blob from the binary data
        const blob = new Blob([bytes], { type: 'application/pdf' });

        // Create a link element for downloading the file
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;

        // Set file name for the download
        link.setAttribute('download', `AISReport${id}.pdf`); // Change file name/extension as needed

        // Append the link to the body and trigger download
        document.body.appendChild(link);
        link.click();

        // Clean up the link element after download
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.error('Error downloading file:', error);
      });
  };



  return (
    <React.Fragment>
      <div style={{ padding: "15px 20px", backgroundColor: "#f5f5f5" }}>
             <Tooltip title="Back" arrow>
                                    <IconButton
                                      onClick={handleBackNavigation}
                                      sx={{
                                        borderRadius: '50%',
                                        padding: '6px',
                                        color: '#263238',
                                        fontSize: '20px',
                                        backgroundColor: '#ffffff',
                                        height: '36px',
                                        width: '36px',
                                        '&:hover': {
                                          backgroundColor: '#455a64',
                                          color: '#ffffff',
                                        },
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                                        transition: 'background-color 0.3s ease',
                                      }}
                                    >
                                      <ArrowBackIcon sx={{ fontSize: '20px' }} />
                                    </IconButton>
                                  </Tooltip>
            </div>

      {/* Upload AIS – ALWAYS VISIBLE */}
      {canWrite("AIS") && (
      <BoxWrapper boxTitle="Upload AIS">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            margin: "auto",
          }}
        >
          <label className="button-primary" style={{ cursor: "pointer" }}>
            Upload
            <input
              type="file"
              accept=".pdf"
              ref={fileInputRef}
              onChange={handleFileUpload}
              hidden
            />
          </label>

          <div>
            <TextField
              value={fileName}
              variant="standard"
              style={{ width: "350px", paddingLeft: "10px" }}
              placeholder="No Data Have Uploaded"
              inputProps={{ readOnly: true }}
            />
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginLeft: "3%",
            }}
          >
            <TextField
              variant="standard"
              placeholder="Enter password"
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{
                marginRight: "10px",
                width: "250px",
                marginBottom: "9px",
              }}
              InputProps={{
                endAdornment: (
                  <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                ),
              }}
            />

            {loaderForFileUpload ? (
              <button
                type="button"
                className="button-primary"
                style={{ marginLeft: "10px" }}
                disabled
              >
                Uploading...
              </button>
            ) : (
              <button
                type="button"
                className="button-primary"
                style={{
                  marginLeft: "10px",
                  cursor: !password ? "not-allowed" : "pointer",
                  opacity: !password ? 0.6 : 1,
                }}
                onClick={handleSubmitEvent}
                disabled={!password}
              >
                Submit
              </button>
            )}

            <button
              type="button"
              className="button-outlined-secondary"
              onClick={fileUploadCancelButtonHandler}
            >
              Cancel
            </button>
          </div>
        </div>

        <p style={{ color: "red" }}>{errorMessage}</p>
      </BoxWrapper>
      )}

      {/* AIS Repository Table */}
      <BoxWrapper
        boxTitle="AIS Repository"
        enableSearchInput={true}
        searchInputPlaceholder="Search..."
        searchInputOnchange={handleSearch}
        enableAddButton={true}
        addButtonLabel="Refresh"
        addButtonHandlerFn={getApiForGst2aRepository}
      >
        <div className="responsive-table">
          <table className="custome-table">
            <thead>
              <tr>
                <th>Date of Incorporation</th>
                <th>PAN</th>
                <th>Financial Year</th>
                <th>Assessment Year</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {loaderForTable ? (
                <tr>
                  <td colSpan={6} style={{ textAlign: "center", fontWeight: "bold" }}>
                    Loading…Please wait
                  </td>
                </tr>
              ) : recordFromApi.length === 0 ? (
                <tr>
                  <td colSpan={6} style={{ color: "red", textAlign: "center" }}>
                    No Data Found!
                  </td>
                </tr>
              ) : (
                recordFromApi.map((item) => (
                  <tr key={item.id}>
                    <td>{item.date_of_incorporation}</td>
                    <td>{item.pan}</td>
                    <td>{item.financial_year}</td>
                    <td>{item.assessment_year}</td>
                    <td>{item.status}</td>
                    <td>
                      <IconButton onClick={() => handleDownload(item.id)}>
                        <DownloadIcon />
                      </IconButton>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </BoxWrapper>

      {/* Snackbar */}
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={handleSnackbarClose}
        style={{ maxWidth: "25%" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
        >
          {responseMessage || message}
        </MuiAlert>
      </Snackbar>

    </React.Fragment>
  );
}
